
const newModel = () => {
    return {
        duongPhoId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        duongPhoId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        duongPhoId: item.duongPhoId,
        ten: item.ten,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        duongPhoId: item.duongPhoId,
        ten: item.ten,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        duongPhoId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const duongPhoModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


